import {envIsIntegration} from '../../../config';
import {type RampKey} from '../../useRampFlag';

/**
 * Shared CI-bypass rule set. Both the Apollo path (`useRampFlag.ts`) and the
 * Zustand store (`useRampFlagStore.ts`) consult this so the two layers stay
 * in lockstep on which entity flags get force-enabled in integration runs.
 */

/**
 * Ramp keys excluded from the "all features on in CI" shortcut - they change
 * screenshot output or are otherwise unsafe to force-enable.
 *
 * `string[]` (not `RampKey[]`): includes legacy keys like
 * `media_panel_individual_loading_entity` that no longer exist in the union
 * but must still be excluded for parity.
 */
const INTEGRATION_BYPASS_EXCLUDED_KEYS: ReadonlyArray<string> = [
  'backend_line_construction_entity',
  'backend_line_construction_grouped_entity',
  'backend_line_construction_user',
  'brsdq_without_run_info_entity',
  'media_browser_modal_enabled_entity',
  'media_panel_individual_loading_entity',
  'semantic-legend-entity',
  'semantic-legend-user',
  'sparse_panel_overrides_user',
  'sparse_compression_user',
];

const INTEGRATION_BYPASS_EXCLUDED_SET: ReadonlySet<string> = new Set(
  INTEGRATION_BYPASS_EXCLUDED_KEYS
);

/**
 * Returns `true` when an entity flag should be force-enabled because we're
 * in a CI integration run and the key isn't on the screenshot-sensitive
 * exclusion list. Both the Apollo and store-backed entity readers gate the
 * "all features on" shortcut on this so the two paths stay in lockstep.
 */
export function isIntegrationBypassActive(rampKey: RampKey | string): boolean {
  return envIsIntegration && !INTEGRATION_BYPASS_EXCLUDED_SET.has(rampKey);
}
